'use client';

import { GalleryCard, thumbGradients } from '../mockups';

// Recreated clip tiles (CSS-only thumbnails). TODO(screenshots): swap for real
// library thumbnails when available.
const clips = [
  { label: 'Interview · 04:20', tags: ['#Product', '#Interview'], g: thumbGradients[0] },
  { label: 'Sunset B-Roll', tags: ['#Nature', '#HighRes'], g: thumbGradients[1] },
  { label: 'Customer Review', tags: ['#Review', '#Testimonial'], g: thumbGradients[2] },
  { label: 'Action Sequence', tags: ['#Sport', '#Action'], g: thumbGradients[4] },
  { label: 'Podcast · 41:08', tags: ['#Podcast', '#Audio'], g: thumbGradients[3] },
  { label: 'Street Trivia', tags: ['#Quiz', '#Fails'], g: thumbGradients[0] },
];

export default function MarqueeGallery() {
  const doubled = [...clips, ...clips];
  return (
    <section className="overflow-hidden bg-mk-s-lowest py-16">
      <div className="group flex w-max animate-marquee gap-6 px-6 hover:[animation-play-state:paused]">
        {doubled.map((c, i) => (
          <GalleryCard key={`${c.label}-${i}`} label={c.label} tags={c.tags} gradient={c.g} />
        ))}
      </div>
    </section>
  );
}
